module.exports = __webpack_public_path__ + "static/media/01.a3ca8d39.jpg";